export const obj = {
    growthRate: {
        qoq: [
            "Revenue",
            "RevenueQoQ",
            "RevenueYoY",
            "NetProfit",
            "NetProfitQoQ",
            "NetProfitYoY",
            "EarningPerShare",
            "EarningPerShareQoQ",
            "EarningPerShareYoY"
        ],
        yoy: [
            "Revenue",
            "RevenueYoY",
            "NetProfit",
            "NetProfitYoY",
            "EarningPerShare",
            "EarningPerShareYoY"
        ]
    },
    financialReport: {
        qoq: [
            "Asset",
            "TotalDebt",
            "Equity",
            "PaidUpCapital",
            "Revenue",
            "GrossProfit",
            "SGA",
            "NetProfit",
            "DA",
            "OperatingActivities",
            "InvestingActivities",
            "FinancingActivities",
            "EarningPerShare"
        ],
        yoy: [
            "Asset",
            "TotalDebt",
            "Equity",
            "PaidUpCapital",
            "Revenue",
            "GrossProfit",
            "SGA",
            "NetProfit",
            "DA",
            "OperatingActivities",
            "InvestingActivities",
            "FinancingActivities",
            "EarningPerShare"
        ]
    },
    financialRatio: {
        qoq: [
            "ROA",
            "ROE",
            "GPM",
            "SGAPerRevenue",
            "NPM",
            "DebtToEquity",
            "CashCycle"
        ],
        yoy: [
            "ROA",
            "ROE",
            "GPM",
            "SGAPerRevenue",
            "NPM",
            "DebtToEquity",
            "CashCycle"
        ]
    },
    statistics: {
        qoq: [
            "Close",
            "MKTCap",
            "PriceEarningRatio",
            "PriceBookValue",
            "BookValuePerShare",
            "DividendYield",
            "EVPerEbitDA"
        ],
        yoy: [
            "Close",
            "MKTCap",
            "PriceEarningRatio",
            "PriceBookValue",
            "BookValuePerShare",
            "DividendYield",
            "EVPerEbitDA"
        ],
        enablePresent: true
    }
}